import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import intl from 'react-intl-universal'
import { Toast } from 'antd-mobile';
import { uploadImageModel, submitOrderModel, judgeOrderModel, initOrderPayModal } from '../model/store';
import { setShoppingCart } from '../utils/storage/store';
import { getPayResultUrl } from '../utils/page';
import math from '../utils/math';
import { selectPromotionActivityId } from '../store/reducers/hotel';
// 订单提交逻辑
const useOrderSubmission = (priceObj, signatureImage, couponInfo, handleNext) => {
    const [loading, setLoading] = useState(false);

    const promotionActivityId = useSelector(selectPromotionActivityId);
    console.log(promotionActivityId, '=====///=====promotionActivityId=====///=====')
    const uploadSignatureImage = useCallback((callback) => {
        if (!signatureImage) {
            callback?.();
            return;
        }
        const fileName = `signatureImage_${Date.now()}.jpg`;
        const imageData = signatureImage.split(',')[1];
        uploadImageModel({ fileName, imageData })
            .then(res => callback?.(res.url))
            .catch(e => {
                console.error(e);
                setLoading(false);
            });
    }, [signatureImage]);

    const submitOrder = useCallback((param, onlinePay, totalPrice, totalPriceObj, options = {}) => {
        if (couponInfo) {
            const { info, priceItem } = couponInfo;
            param.couponRuleId = info.couponRuleId;
            param.couponNum = info.couponNum;
            param.discountPrice = couponInfo.reduceAmount;
            // param.totalPrice = priceItem.totalPrice;
            // param.totalPrice = math.sub(totalPrice, couponInfo.reduceAmount);
            if (!options.keepPreviewTotal) {
                param.totalPrice = math.add(totalPriceObj.totalIncludeFee, priceItem.totalPrice);
            }
        }
        submitOrderModel(param)
            .then(res => {
                setShoppingCart([], param.storeId);
                const resultUrl = getPayResultUrl(res.orderId)

                if (onlinePay && onlinePay.enable) {
                    const payData = onlinePay.data
                    console.log(onlinePay, '=====///=====onlinePay=====///=====')
                    setLoading(true)
                    initOrderPayModal({
                        orderId: res.orderId,
                        partnerId: payData.partnerId,
                        paymentMethod: payData.payMethod,
                        returnUrl: resultUrl,
                        cancelUrl: resultUrl + '&result=cancel',
                    }).then(result => {
                        console.log(result, '=====///=====res=====///=====')
                        const { dwz = {}, context_data } = result
                        const { urlVal } = dwz
                        const payHref = urlVal || context_data
                        setLoading(false)
                        if (payHref) {
                            //this.setState({ payUrl: urlVal, payVisible: true })

                            Toast.show({
                                icon: 'loading',
                                content: intl.get('redirect_pay').d('正在跳转支付，请稍后...')
                            })
                            setTimeout(() => {
                                handleNext(null, null, true);
                            }, 3000)
                            window.location.href = payHref
                        } else {
                            Toast.show({
                                icon: 'fail',
                                content: 'No payment info'
                            })
                        }

                    }).catch(e => {
                        console.error(e);
                        setLoading(false)
                    })
                } else {
                    setLoading(false)
                    handleNext(null, res.orderId);
                }
            })
            .catch(e => {
                console.error(e);
                setLoading(false);
            })
        // .finally(() => setLoading(false));
    }, [couponInfo, handleNext]);

    const previewOrder = useCallback(({ param, onlinePay, totalPriceObj, normalPriceObj, thirdPartyPreview }) => {
        console.log(normalPriceObj,totalPriceObj, '=====///=====normalPriceObj=====///=====')
        const localTotal = math.add(normalPriceObj.totalPrice, totalPriceObj.totalIncludeFee);
        setLoading(true);
        judgeOrderModel(param, thirdPartyPreview ? { isPreview: false } : undefined)
            .then((res) => {
                const totalPrice = thirdPartyPreview && res?.totalPrice != null ? res.totalPrice : localTotal;
                uploadSignatureImage((url) => {
                    try {
                        const extData = typeof param.extendColumn === 'string'
                            ? JSON.parse(param.extendColumn)
                            : param.extendColumn;
                        extData.electronicSignature = url;
                        param.extendColumn = JSON.stringify(extData);
                        // param.totalPrice = math.add(productPriceIncludeFee, (nPriceObj ? nPriceObj.totalPrice : priceObj.totalPrice));
                        param.totalPrice = totalPrice;
                        param.activityId = promotionActivityId;
                        submitOrder(param, onlinePay, totalPrice, totalPriceObj, { keepPreviewTotal: !!thirdPartyPreview });
                    } catch (error) {
                        console.error('处理 extendColumn 时出错:', error);
                        setLoading(false);
                    }
                });
            })
            .catch(e => {
                console.error(e);
                setLoading(false);
            });
    }, [uploadSignatureImage, submitOrder, priceObj]);

    return { loading, previewOrder };
};

export default useOrderSubmission; 